import {Action} from '@ngrx/store';

import {ArrayResponse} from '../models/array-response';
import {TagsList} from '../models/tags-list';
import {type} from '../utilities/type';

export const TagsListActionTypes = {
  LOAD: type('[TagsList] Load'),
  LOAD_SUCCESS: type('[TagsList] Load Success'),
  LOAD_FAIL: type('[TagsList] Load Fail')
};

export class LoadTagsListAction implements Action {
  readonly type = TagsListActionTypes.LOAD;

  constructor() {}
}

export class LoadTagsListSuccessAction implements Action {
  readonly type = TagsListActionTypes.LOAD_SUCCESS;

  constructor(public payload?: ArrayResponse<TagsList>) {}
}

export class LoadTagsListFailAction implements Action {
  readonly type = TagsListActionTypes.LOAD_FAIL;

  constructor(public payload?: number) {}
}
